<template>
  <div class="coupon">
     <div class="coupon-container">

        <div class="coupon-card-container" v-for="(item,index) in promotionData" v-if="item.PromoCode">
          <div class="coupon-card">
            <div class="coupon-title">
              {{getPromoTitle(item)}}
            </div>
            <div class="coupon-info">
              <p>{{item.Name}}</p>
              <p>{{item.DiscountDescription}}</p>
            </div>
            <div class="coupon-expires">
              <!-- {{ $t('expires') }}: {{getExpireDate(item.Expires)}} -->
              {{ $t('expires') }}: {{getExpireDate(item.EndDate)}}
            </div>
            <div class="coupon-code-top">
              {{$t('code')}}
            </div>
            <div class="coupon-code-bottom">
              <p class="bottom-code">{{item.PromoCode}}</p>
              <!-- <button class="bottom-copy" >Copy</button> -->
              <p v-clipboard:copy="item.PromoCode" v-clipboard:success="copy" class="bottom-copy">{{ $t('copy') }}</p>
            </div>
          </div>
        </div>

     </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import {promoCodeList} from "../../mixin";
export default {
  name: "coupon",
  mixins: [promoCodeList],
  data(){
    return{}
  },
  methods:{
    copy() {
      this.$notify({
        type: 'success',
        title: 'Code Copied',
        // message: '分享链接给好友',
        position: 'bottom-right',
        duration: 2000
      });
    }
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
  })
}
</script>
<style scoped lang="less">
// @import "../../assets/css/profileorder.less";
@import "../../assets/css/public";
@import "../../assets/css/coupon.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/coupon.vue